// Token Management Utility
// ใช้สำหรับ debug และจัดการ token

/**
 * Set authentication token
 * @param {string} token - The token to store
 * @param {string} storageType - 'localStorage' or 'sessionStorage'
 */
export const setAuthToken = (token, storageType = 'localStorage') => {
    if (!token) {
      console.error('Token is required');
      return false;
    }
    
    try {
      if (storageType === 'sessionStorage') {
        sessionStorage.setItem('token', token);
      } else {
        localStorage.setItem('token', token);
      }
      
      console.log('Token saved successfully');
      return true;
    } catch (error) {
      console.error('Error saving token:', error);
      return false;
    }
  };
  
  /**
   * Get authentication token
   * @returns {string|null} The token or null if not found
   */
  export const getAuthToken = () => {
    const token = 
      // localStorage.getItem('authToken') || 
      // localStorage.getItem('token') || 
      // localStorage.getItem('access_token') ||
      // sessionStorage.getItem('authToken') ||
      sessionStorage.getItem('token');
    
    return token;
  };
  
  /**
   * Remove authentication token
   */
  export const removeAuthToken = () => {
    // localStorage.removeItem('authToken');
    // localStorage.removeItem('token');
    // localStorage.removeItem('access_token');
    // sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('token');
    
    console.log('Token removed');
  };
  
  /**
   * Check if user is authenticated
   * @returns {boolean} True if token exists
   */
  export const isAuthenticated = () => {
    const token = getAuthToken();
    return !!token;
  };
  
  /**
   * Debug function to check current authentication status
   */
  export const debugAuth = () => {
    const token = getAuthToken();
    
    // console.log('=== Authentication Debug ===');
    // console.log('Has token:', !!token);
    // console.log('Token preview:', token ? `${token.substring(0, 20)}...` : 'No token');
    // console.log('LocalStorage authToken:', localStorage.getItem('authToken') ? 'YES' : 'NO');
    // console.log('LocalStorage token:', localStorage.getItem('token') ? 'YES' : 'NO');
    // console.log('LocalStorage access_token:', localStorage.getItem('access_token') ? 'YES' : 'NO');
    // console.log('SessionStorage authToken:', sessionStorage.getItem('authToken') ? 'YES' : 'NO');
    // console.log('SessionStorage token:', sessionStorage.getItem('token') ? 'YES' : 'NO');
    // console.log('============================');
    
    return {
      hasToken: !!token,
      token: token,
      isAuthenticated: !!token
    };
  };
  
  /**
   * Temporarily set a test token for debugging
   * WARNING: ใช้เฉพาะการ debug เท่านั้น!
   */
  export const setTestToken = (testToken = 'test-token-123') => {
    //console.warn('WARNING: Setting test token for debugging purposes only!');
    setAuthToken(testToken);
    debugAuth();
  };
  
  export default {
    setAuthToken,
    getAuthToken,
    removeAuthToken,
    isAuthenticated,
    debugAuth,
    setTestToken
  };